import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Box, Select } from "@chakra-ui/react";
import InstalledCrm from "./InstalledCrm";
import NotInstalledCrm from "./NotInstalledCrm";
import NotCrmUser from "./NotCrmUser";
import { setConfigType } from "../../../../redux/actions/integrationActions";
const Body = ({ integrateType, dispatchSetConfigType }) => {
  const handleOnChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    dispatchSetConfigType(value);
  };

  const renderBody = () => {
    switch (integrateType) {
      case "INSTALLED_CRM":
        return <InstalledCrm />;
      case "NOT_INSTALLED_CRM":
        return <NotInstalledCrm />;
      case "NOT_CRM_USER":
        return <NotCrmUser />;
    }
  };
  return (
    <Box mt="16px">
      <select
        value={integrateType}
        onChange={handleOnChange}
        style={{
          minWidth: "616px",
          height: "32px",
          border: "1px solid #CFD7DF",
          borderRadius: "4px",
          color: "#12344D",
          fontWeight: "600",
          fontSize: "14px",
        }}
      >
        <option
          value="INSTALLED_CRM"
          style={{
            minWidth: "599px",
            height: "32px",
            color: "#12344D",
            fontWeight: "600",
            fontSize: "14px",
          }}
        >
          {" "}
          I’m a Freshworks CRM user and I have installed the WordPress - CRM
          plugin
        </option>
        <option
          value="NOT_INSTALLED_CRM"
          style={{
            minWidth: "616px",
            height: "32px",
            color: "#12344D",
            fontWeight: "600",
            fontSize: "14px",
          }}
        >
          {" "}
          I’m a Freshworks CRM user but I have not installed the WordPress - CRM
          plugin
        </option>
        <option
          value="NOT_CRM_USER"
          style={{
            minWidth: "616px",
            height: "32px",
            color: "#12344D",
            fontWeight: "600",
            fontSize: "14px",
          }}
        >
          I’m not a Freshworks CRM user
        </option>
      </select>
      {/* Edit Section */}
      {renderBody()}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    integrateType: state.integration.configType,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchSetConfigType: bindActionCreators(setConfigType, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Body);
